import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import profileApi from "api/profile";
import { scrollIntoView } from "utils/helper";

function UseQualificationsInformation() {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});

  const [isLoading, setIsLoading] = useState(false);

  const { notifyError, notifySuccess } = useNotify();

  const onEditQualifications = async (values) => {
    try {
      setIsLoading(true);

      const payload = { qualifications: values };

      await profileApi.updateVendorQualifications(
        userDetails?.vendorId,
        payload
      );

      userDetails.extraInformation.qualifications = values;
      dispatch(actions.setUserDetails(userDetails));

      notifySuccess("Has been updated successfully");
      scrollIntoView("qualificationsScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    onEditQualifications,
    isQualificationsLoading: isLoading,
  };
}

export default UseQualificationsInformation;
